export default "__VITE_ASSET__BEauZklc__"